import React from 'react';

export default class DeleteButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            deleteingDoc: null
        }
    }

    delete  (id, func)  {
       func && func(id)
        this.setState({
            ...this.state,
            deleteingDoc: id
        })
    }

    confirm = async (id, func, array, index) => {
        try {
        await func && func(id)
        array.remove(index)
        } catch (e) {
        console.log(e) 
        }
         this.cancel()
    }

    cancel = (func) => {
        func && func()
        this.setState({
            ...this.state,
            deleteingDoc: null
        })
    }


    render() {
        const { onDeleteClick,
            onCancelClick,
            onConfirmClick,
            item
        } = this.props
        return (
            <React.Fragment>
                {/* <PrivilegedContent permissions={['readAny:note']}> */}
                {this.state.deleteingDoc !== item.id ?
                    <button className="deleteDoc-button button-black" type="button" onClick={() => this.delete(item.id, onDeleteClick)}>delete</button>
                    :
                    <div>
                        <button className="deleteDoc-button button-black" type="button" onClick={() => this.confirm(item.id, onConfirmClick, this.props.arrayHelpers, this.props.index)}> confirm</button>
                        <button className="deleteDoc-button button-white" type="button" onClick={() => this.cancel(onCancelClick)}> cancel</button>
                    </div>
                }
                {/* </PrivilegedContent> */}
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/DeleteButton.jsx